<template>
  <DashboardPanel
    panel-id="v-pills-jobdetails"
    aria-labelledby="v-pills-jobdetail-tab"
    title="My jobs"
    subtitle="Latest recommended job openings and your applications"
    body-class="hc-panel__body--flush"
  >
      <div class="hc-profile-jobs" id="myjobs">
        <ul class="nav nav-pills mb-0 hc-job-tabs" id="pills-tab" role="tablist">
          <li class="nav-item hc-job-tabs__item" role="presentation">
            <button type="button" class="nav-link hc-job-tab" :class="{'active': tab == 'recommended-jobs'}" id="pills-recommend-tab" role="tab" :aria-selected="tab == 'recommended-jobs'" @click="tab='recommended-jobs'">
              <span class="hc-job-tab__label">Recommended</span>
            </button>
          </li>
          <li class="nav-item hc-job-tabs__item" role="presentation">
            <button type="button" class="nav-link hc-job-tab" id="pills-applied-tab" :class="{'active': tab == 'applied-jobs'}" role="tab" :aria-selected="tab == 'applied-jobs'" @click="tab='applied-jobs'">
              <span class="hc-job-tab__label">Applied</span>
            </button>
          </li>
          <li class="nav-item hc-job-tabs__item" role="presentation" v-if="institute_jobs.length > 0">
            <button type="button" class="nav-link hc-job-tab" id="pills-institute-tab" :class="{'active': tab == 'institute-jobs'}" role="tab" :aria-selected="tab == 'institute-jobs'" @click="tab='institute-jobs'">
              <span class="hc-job-tab__label">Institute</span>
              <span class="hc-job-tab__count">{{ institute_jobs.length }}</span>
            </button>
          </li>
          <li class="nav-item hc-job-tabs__item" role="presentation" v-if="college_jobs.length > 0">
            <button type="button" class="nav-link hc-job-tab" id="pills-college-tab" :class="{'active': tab == 'college-jobs'}" role="tab" :aria-selected="tab == 'college-jobs'" @click="tab='college-jobs'">
              <span class="hc-job-tab__label">College</span>
              <span class="hc-job-tab__count">{{ college_jobs.length }}</span>
            </button>
          </li>
        </ul>
        <div class="tab-content jobDetailProfile" id="pills-tabContent">
          <div id="pills-recommend" role="tabpanel" aria-labelledby="pills-recommend-tab" v-if="tab == 'recommended-jobs'">
            <div class="jl-results jl-results--profile" v-if="jobs_loading">
              <div class="jl-card jl-card--skeleton" v-for="n in 3" :key="'skel-' + n">
                <content-loader viewBox="0 0 700 100" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
                  <rect x="0" y="0" rx="8" ry="8" width="48" height="48" />
                  <rect x="64" y="8" rx="4" ry="4" width="220" height="16" />
                  <rect x="64" y="32" rx="4" ry="4" width="160" height="12" />
                  <rect x="64" y="52" rx="4" ry="4" width="280" height="10" />
                </content-loader>
              </div>
            </div>

            <div class="hc-panel__empty" v-else-if="!jobs.length">
              <i class="mdi mdi-briefcase-search-outline hc-panel__empty-icon" aria-hidden="true"></i>
              <h3>No recommended jobs right now</h3>
              <p>Complete your profile and visume so our system can match you with the best opportunities.</p>
              <a class="hc-modal__btn hc-modal__btn--primary" href="/jobs">Browse all jobs</a>
            </div>

            <div class="jl-results jl-results--profile" v-else>
              <p class="jl-result-count">{{ jobs.length }} jobs matched to your profile</p>
              <JobCardList
                v-for="job in jobs"
                :key="job.job_id"
                :job="job"
                :applied="!!job.applied"
              />
              <div class="jl-results__footer">
                <a class="hc-modal__btn hc-modal__btn--ghost" href="/jobs">View all jobs</a>
              </div>
            </div>
          </div>

          <div id="pills-applied" role="tabpanel" aria-labelledby="pills-applied-tab" v-if="tab == 'applied-jobs'">
            <div class="jl-results jl-results--profile" v-if="appliedjobs_loading">
              <div class="jl-card jl-card--skeleton" v-for="n in 2" :key="'askel-' + n">
                <content-loader viewBox="0 0 700 100" primaryColor="#f1f5f9" secondaryColor="#e2e8f0">
                  <rect x="0" y="0" rx="8" ry="8" width="48" height="48" />
                  <rect x="64" y="8" rx="4" ry="4" width="220" height="16" />
                  <rect x="64" y="32" rx="4" ry="4" width="160" height="12" />
                  <rect x="64" y="52" rx="4" ry="4" width="280" height="10" />
                </content-loader>
              </div>
            </div>

            <div class="hc-panel__empty" v-else-if="!appliedJobs.length">
              <i class="mdi mdi-file-document-outline hc-panel__empty-icon" aria-hidden="true"></i>
              <h3>No jobs applied yet</h3>
              <p>Explore recommended jobs and apply to roles that match your profile.</p>
              <button type="button" class="hc-modal__btn hc-modal__btn--primary" @click="tab='recommended-jobs'">View recommended jobs</button>
            </div>

            <div class="jl-results jl-results--profile" v-else>
              <p class="jl-result-count">Your last {{ appliedJobs.length }} application{{ appliedJobs.length === 1 ? '' : 's' }}</p>
              <AppliedJobCard
                v-for="applied_job in appliedJobs"
                :key="applied_job.job_id"
                :applied-job="applied_job"
              />
            </div>
          </div>
          <div class="" id="pills-institute" role="tabpanel" aria-labelledby="pills-institute-tab" v-if="tab == 'institute-jobs'">
            <div v-if="insti_jobs_loading">
              <div class="card">
                <div class="card-body jobBox">
                  <content-loader viewBox="0 0 476 124" primaryColor="#f3f3f3" secondaryColor="#cccccc" v-if="insti_jobs_loading">
                    <rect x="0" y="8" rx="3" ry="3" width="150" height="10" />
                    <rect x="0" y="30" rx="3" ry="3" width="120" height="6" />
                    <rect x="0" y="45" rx="3" ry="3" width="105" height="6" />
                    <rect x="0" y="60" rx="3" ry="3" width="115" height="6" />
                    <rect x="0" y="75" rx="3" ry="3" width="110" height="6" />
                    <rect x="0" y="90" rx="3" ry="3" width="130" height="6" />
                    <rect x="300" y="110" rx="3" ry="3" width="110" height="6" />
                  </content-loader>
                </div>
              </div>
            </div>
            <div class="row" v-if="institute_jobs.length&& !insti_jobs_loading">
              <div class="col-md-12 mb-2" v-for="job in institute_jobs" :key="job.job_id">
                <div class="card">
                  <div class="card-body jobBox">
                    <div class="row">
                      <div class="col-md-12 job-list-logo-wrap">
                        <JobCompanyLogo
                          :company-name="job.company_name || job.job_designation"
                          :logo-url="job.company_logo_url"
                          root-class="job-list-logo"
                        />
                        <div class="job-list-logo-wrap__content">
                        <a class="mob-applay-btn m-show" target="_blank" :href="'/job/'+job.job_url"></a>
                        <h6 class="jobTitle ">
                          <a class="text-decoration-none" target="_blank" :href="'/job/'+job.job_url">{{job.job_designation}}</a>
                        </h6>
                          <p v-if="job.company_name">
                            <span class="jobIcon"><img :src="$S3_url+'/Assets/images/company.svg'" alt="company name" title="company name" width="18"></span>
                            {{job.company_name}}
                          </p>
                          <p v-if="job.cities">
                            <span class="jobIcon"><img :src="$S3_url+'/Assets/images/location.svg'" alt="location" title="location" width="22"></span>
                            <span>{{job.cities}}</span>
                          </p>
                          <p>
                            <span class="jobIcon"><img :src="$S3_url+'/Assets/images/calander.svg'" alt="last date to apply" title="Last date to apply" width="20"></span>
                            Last date to apply: {{job.last_date}} </p> 
                          <p class="postDate"  v-if="job.date_of_posting">{{ calculatePostDate(job.date_of_posting) }}
                          </p>
                        
                          <div class="jobButton  m-hide">
                            <a class="btn btn-outline-primary mobright" :href="'/job/'+job.job_url" target="_blank"><span>View & Apply</span></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div> 
              </div>     
            </div>
            <div class="col" v-else>
                <div class="container text-center mt-5 mb-5" style="color:#afafaf;">
                  <h3><strong> NO JOBS SHARED YET </strong></h3>
                </div>
              </div>
          </div>
          <div class="" id="pills-college" role="tabpanel" aria-labelledby="pills-college-tab" v-if="tab == 'college-jobs'">
            <div v-if="college_jobs_loading">
              <div class="card">
                <div class="card-body jobBox">
                  <content-loader viewBox="0 0 476 124" primaryColor="#f3f3f3" secondaryColor="#cccccc" v-if="insti_jobs_loading">
                    <rect x="0" y="8" rx="3" ry="3" width="150" height="10" />
                    <rect x="0" y="30" rx="3" ry="3" width="120" height="6" />
                    <rect x="0" y="45" rx="3" ry="3" width="105" height="6" />
                    <rect x="0" y="60" rx="3" ry="3" width="115" height="6" />
                    <rect x="0" y="75" rx="3" ry="3" width="110" height="6" />
                    <rect x="0" y="90" rx="3" ry="3" width="130" height="6" />
                    <rect x="300" y="110" rx="3" ry="3" width="110" height="6" />
                  </content-loader>
                </div>
              </div>
            </div>
            <div class="row" v-if="college_jobs.length&& !insti_jobs_loading">
              <div class="col-md-12 mb-2" v-for="job in college_jobs" :key="job.job_id">
                <div class="card">
                  <div class="card-body jobBox">
                    <div class="row">
                      <div class="col-md-12 job-list-logo-wrap">
                        <JobCompanyLogo
                          :company-name="job.company_name || job.job_designation"
                          :logo-url="job.company_logo_url"
                          root-class="job-list-logo"
                        />
                        <div class="job-list-logo-wrap__content">
                        <a class="mob-applay-btn m-show" target="_blank" :href="'/job/'+job.job_url"></a>
                        <h6 class="jobTitle ">
                          <a class="text-decoration-none" target="_blank" :href="'/job/'+job.job_url">{{job.job_designation}}</a>
                        </h6>
                          <p v-if="job.company_name">
                            <span class="jobIcon"><img :src="$S3_url+'/Assets/images/company.svg'" alt="company name" title="company name" width="18"></span>
                            {{job.company_name}}
                          </p>
                          <p v-if="job.cities">
                            <span class="jobIcon"><img :src="$S3_url+'/Assets/images/location.svg'" alt="location" title="location" width="22"></span>
                            <span>{{job.cities}}</span>
                          </p>
                          <p>
                            <span class="jobIcon"><img :src="$S3_url+'/Assets/images/calander.svg'" alt="last date to apply" title="Last date to apply" width="20"></span>
                            Last date to apply: {{getDate(job.last_date)}} </p> 
                          <p class="postDate"  v-if="job.date_of_posting">{{job.date_of_posting  | moment("from", "now", true) }} ago
                          </p>
                        
                          <div class="jobButton  m-hide">
                            <a class="btn btn-outline-primary mobright" :href="'/job/'+job.job_url" target="_blank"><span>View & Apply</span></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div> 
              </div>     
            </div>
            <div class="col" v-else>
                <div class="container text-center mt-5 mb-5" style="color:#afafaf;">
                  <h3><strong> NO JOBS SHARED YET </strong></h3>
                </div>
              </div>
          </div>
        </div>
      </div>
  </DashboardPanel>
</template>

<script>
import moment from 'moment';
import validation from '../libraries/validFormat' ;
import Actions from '../libraries/apiActions.js';
import DashboardPanel from './Dashboard/DashboardPanel.vue';
import '../assets/hire.css';
import '../assets/jobs-list-page.css';
import Vue from 'vue'
import { ContentLoader } from 'vue-content-loader';
import JobCardList from '@/components/JobCardList.vue';
import AppliedJobCard from '@/components/AppliedJobCard.vue';
import JobCompanyLogo from '@/components/JobCompanyLogo.vue';

export default {
  name: 'JobDetails',
  components: {
    ContentLoader,
    JobCardList,
    AppliedJobCard,
    JobCompanyLogo,
    DashboardPanel,
  },
  data(){
    return{
      action: new Actions(),
      validate: new validation(),
      jobs:[],
      rec_jobs:[],
      all_jobs:[],
      job_flag:0,
      pages:[],
      page:1,
      limit:10,
      locations:[],
      filter:{
        job_role:null,
        city_id:null,
        limit: 0
      },
      institute_jobs: [],
      college_jobs: [],
      institute_meta: {
        limit: 10,
        offset: 0,
        total: 0
      },
      college_meta: {
        limit: 10,
        offset: 0,
        total: 0
      },
      user:null,
      appliedJobs:[],
      tab:'recommended-jobs',
      jobs_loading:true,
      insti_jobs_loading:false,
      college_jobs_loading:false,
      appliedjobs_loading:true,
    }
  },
  beforeMount(){
    this.action.getUser(this.$cookies.get("hire-seeker").token).then(res => { 
      if(res){
        this.user= res.user; 
        this.filter.job_role = (this.user.careerPreferencesDetail?.fst_prefered_role)?this.user.careerPreferencesDetail?.fst_prefered_role:null;
        this.filter.city_id = (this.user.personal_details?.city_id)?this.user.personal_details?.city_id:null;
        this.filter.user_id = this.user.id;  
        this.filter.limit = this.limit;
        this.getJobList();
        this.InstitutePrivateJobs();
        this.CollegePrivateJobs();
      }
    });
    this.getStates();
  },
  methods:{
    calculatePostDate(date) {
      const dateObject = new Date(date * 1000);
      return moment(dateObject).fromNow();
    },
    async getJobList() {
      try {
        const response = await this.action.getJobList({
          limit: this.filter.limit,
          user_id: this.filter.user_id
        });
        
        this.rec_jobs = response.jobs;
        this.jobs = this.rec_jobs;

        if (response.meta.total < this.limit) {
          this.filter.limit = this.limit - response.meta.total;
          this.filter.job_role = null;
          this.filter.city_id = null;
          
          const additionalJobs = await this.action.getJobList(this.filter);
          
          for (const job of additionalJobs.jobs) {
            if (this.rec_jobs.length < 10) {
              const matchingJobs = this.rec_jobs.filter(r_job => r_job.job_id === job.job_id);
              if (matchingJobs.length === 0) {
                job.last_date = this.validate.convertTimestamp(job.last_date);
                this.jobs.push(job);
              }
            }
          }

          for (const job of this.jobs) {
            job.last_date = this.validate.convertTimestamp(job.last_date);
            let param = job.job_url ? job.job_url : '';
            param = param.replace(/[^A-Z0-9]+/ig, "-");
            
            if (param.length > 80) {
              const param_split = param.split("-");
              const id_length = param_split[param_split.length - 1].length;
              param = param.substring(0, 80 - (id_length + 1)) + '-' + param_split[param_split.length - 1];
            }
            
            job.param = param;
          }
          
          this.jobs_loading = false;
          this.getAppliedJobList();
        } else {
          this.jobs_loading = false;
          this.jobs = response.jobs;
          
          for (const job of this.jobs) {
            job.last_date = this.validate.convertTimestamp(job.last_date);
            let param = job.job_url ? job.job_url : '';
            param = param.replace(/[^A-Z0-9]+/ig, "-");
            
            if (param.length > 80) {
              const param_split = param.split("-");
              const id_length = param_split[param_split.length - 1].length;
              param = param.substring(0, 80 - (id_length + 1)) + '-' + param_split[param_split.length - 1];
            }
            
            job.param = param;
          }
          
          this.getAppliedJobList();
        }

        this.filter.limit = this.limit;
      } catch (error) {
        // Handle any errors here
        console.error(error);
      }
    },
    InstitutePrivateJobs(){
      this.insti_jobs_loading = true;
      let token = this.$cookies.get("hire-seeker").token;
      let param = '?limit='+this.institute_meta.limit+'&offset='+this.institute_meta.offset
      this.action.getInstitutePrivateJobs(param,token).then((res) => {
          this.institute_meta.offset = res.meta.offset;
          this.institute_meta.limit = res.meta.limit;
          this.institute_meta.total = res.meta.total;
          this.institute_jobs = res.jobs;
          this.insti_jobs_loading = false;
      });
    },
    CollegePrivateJobs(){
      this.college_jobs_loading = true;
      let token = this.$cookies.get("hire-seeker").token;
      let param = '?limit='+this.college_meta.limit+'&offset='+this.college_meta.offset
      this.action.getCollegePrivateJobs(param,token).then((res) => {
          console.log('--->>', res);
          this.college_meta.offset = res.meta.offset;
          this.college_meta.limit = res.meta.limit;
          this.college_meta.total = res.meta.total;
          this.college_jobs = res.jobs;
          this.college_jobs_loading = false;
      });
    },
    getDate(ts){
        var timestamp = ts * 1000;
        var date = new Date(timestamp);
        return this.pad(date.getDate())+
            "-"+this.pad(date.getMonth()+1)+
            "-"+date.getFullYear()
    },
    pad(n){
      if(n < 10) return '0'+n; else return n;
    },
    getAppliedJobList(){
      this.action.getAppliedJobList(this.user.id, this.$cookies.get("hire-seeker").token).then((res) => {
        this.appliedjobs_loading = false;
        res.applied_jobs.forEach(job => {
          let param = job.job.job_url?job.job.job_url:'';
          param = param.replace(/[^A-Z0-9]+/ig, "-");
          if(param.length > 80){
            let param_split = param.split("-");
            let id_length = param_split[param_split.length-1].length;
            param = param.substring(0, 80-(id_length+1));
            param = param+'-'+param_split[param_split.length-1];
          }
          job.param = param;
          this.appliedJobs.push(job);
        })
        this.checkIfApplied(this.jobs)
        this.checkIfApplied(this.institute_jobs)
      });
    },
    checkIfApplied: function(job_list){
      job_list.forEach(job => {
        const isApplied = this.appliedJobs.some(appliedJob => appliedJob.job_id === job.job_id);
        Vue.set(job, 'applied', isApplied);
      });
    },
    generateJobUrl: function(job_list){
      job_list.forEach(job => {
          job.last_date = this.validate.convertTimestamp(job.last_date);
          let param = job.job_url?job.job_url:'';
          param = param.replace(/[^A-Z0-9]+/ig, "-");
          if(param.length > 80){
            let param_split = param.split("-");
            let id_length = param_split[param_split.length-1].length;
            param = param.substring(0, 80-(id_length+1));
            param = param+'-'+param_split[param_split.length-1];
          }
          job.param = param;
        });
    },
    getStates: async function () {
      await this.action.getStates().then(async (data) => {
        this.locations.push({header: 'Top Metropolitan Cities'})
        await data.states.forEach(async (element) => {
          await element.cities.forEach(city => {
            if(city.top_city == 1){
              this.locations.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
            }
          });
          this.locations.push({divider:true})
          this.locations.push({header: element.state_name});
          element.cities.forEach(city => {
            if(city.top_city == 0){
              this.locations.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:element.state_name})
            }
        });
      });
      });
    },
    getRecommendedJobs(e){
      e.target.classList.add('active');
      document.getElementById('pills-applied-tab').classList.remove('active');

      document.getElementById('pills-recommend').classList.add('active');
      document.getElementById('pills-applied').classList.remove('active');
    },
    getAppliedJobs(e){
      e.target.classList.add('active');
      document.getElementById('pills-recommend-tab').classList.remove('active');

      document.getElementById('pills-recommend').classList.remove('active');
      document.getElementById('pills-applied').classList.add('active');
    }
  }
}
</script>

